import { RECEIVE_ALL_ATTACHMENTS, RECEIVE_ATTACHMENT } from '../actions/attachment_actions';
var _ = require('lodash')
const attachments_reducer = (oldState = {}, action) => {
    Object.freeze(oldState);

    switch (action.type) {
        case RECEIVE_ALL_ATTACHMENTS:
            const attachments = _.mapKeys(action.attachments, "_id")
            let normalizedAttachments = { ...oldState, ...attachments }
            return normalizedAttachments
        case RECEIVE_ATTACHMENT:
            let nextState = _.cloneDeep(oldState)
            nextState[action.attachment._id] = action.attachment
            return nextState
        default:
            return oldState;
    }
};

export default attachments_reducer;